module.exports = __webpack_public_path__ + "static/10-e52d03f82a9923a4e20e60c5119cddde.jpeg";